import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/common/common.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NewListViewDetailsComponent } from '../new-list-view-details/new-list-view-details.component';
import { DatePipe } from "@angular/common";
import * as moment from "moment";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { RecConfirmModalComponent } from '../rec-confirm-modal/rec-confirm-modal.component';
import { ViewEmployeeComponent } from '../../view-employee/view-employee.component';
import { AddShiftComponent } from '../add-shift/add-shift.component';
import { PaginationInstance } from 'ngx-pagination';
import { GlobalService } from 'src/app/services/global/global.service';
@Component({
  selector: 'app-new-list-view',
  templateUrl: './new-list-view.component.html',
  styleUrls: ['./new-list-view.component.scss']
})
export class NewListViewComponent {


  public pageSizeOptions = GlobalService.pageSizeOptions;
  panelOpenState = false;
  public listArr: any[] = []
  expandedPanels: boolean[] = [];
  public searchInput: string = '';
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  private previousInputValue: string = '';

  public newListArr: any[] = [];
  public isSpinnerLoading: boolean = false;
  public startDate: any;
  public endDate: any;
  public dateForm!: FormGroup;
  constructor(
    private recruiterService: RecruiterService,
    private commonService: CommonService,
    private dialog: MatDialog,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    private dilogRef: MatDialogRef<NewListViewComponent>,
  ) { }

  ngOnInit() {

    // this function is used to get the last 15 days data, end date is the today's date
    this.endDate = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.startDate;
    if (this.endDate) {
      this.startDate = moment().subtract(1, "days").format("yyyy-MM-DD");
    }
    this.dateForm = this.fb.group({
      start: ["", Validators.required],
      end: ["", Validators.required],
    });
    this.dateForm.get("start")?.setValue(this.startDate);
    this.dateForm.get("end")?.setValue(this.endDate);
    this.list()


    this.dateForm.valueChanges.subscribe((value) => {
      const { start, end } = value;
      const startDate = new Date(start);
      const endDate = new Date(end);
      if (startDate > endDate) return;
      if (start && end) {
        this.list()
      }

    });
  }

  onGo() {
    if (this.searchInput.trim() != '') {
      this.config.currentPage = 0
      this.list()
    }
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage = 0
      this.list()
    }
  }

  list() {
    let obj = {
      "st_dt": this.datePipe.transform(
        this.dateForm.get("start")?.value,
        "yyyy-MM-dd"
      ),
      "ed_dt": this.datePipe.transform(
        this.dateForm.get("end")?.value,
        "yyyy-MM-dd"
      ),
      // "st_dt": "2024-11-21",
      // "ed_dt": "2024-12-09",
      "r_p": "30",
      sh: this.searchInput.trim(),
    }
    this.isSpinnerLoading = true;
    this.recruiterService.newListView(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          
          this.previousInputValue = this.searchInput;
          this.newListArr = [];
          this.newListArr = success.msg;
          this.isSpinnerLoading = false;
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      }
    })
  }

  onOpendetailsModel(jobCategory: any, st_dt: any) {
    const dialogRef = this.dialog.open(NewListViewDetailsComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", width: '95%', height: '98%', maxWidth: '90vw',
      // minHeight:'200px'
      data: { j_c: jobCategory, st_dt: st_dt }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.list()
    });
  }

  closeDialog() {
    this.dilogRef.close()
  }

  onConfirmationModal(element, type, jobId: any) {
    if (element.app == type) { return }
    let data = {
      type: "shift_request",
      text: "status",
      reqObj: {
        app: type, //1 : accep, 0:reject
        em_i: element.em_i,
        j_id: jobId,

      }
    }
    const dialogRef = this.dialog.open(RecConfirmModalComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", data: data,
    });
    dialogRef.afterClosed().subscribe(result => {
      this.list()
      if (result && result["confirm"] == 'yes') {
      }
    });
  }


  onViewEmployee(id) {
    let data = {
      employee_id: id,
      type: 'company'
    }
    const dialogRef = this.dialog.open(ViewEmployeeComponent, {
      width: '95%',
      height: '95vh',
      maxWidth: '95vw',
      panelClass: 'onboard-modal',
      data: data,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  acceptAll(jobId: any) {
    const data = {
      "j_id": jobId
    }
    // this.isSpinnerLoading = true;
    this.recruiterService.onAcceptAllUserForSpecificJob(data).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

  onEdit(item, tabType) {
    let newData = {
      addType: "single",
      modalType: "open_shift",
      // date: item.st_dt,
      // date: this.data.st_dt,
      tabType: tabType,
      shift_data: {
        id: item.id,
        comm_id: item.comm_id,
        em_i: "",
      }
    }
    const dialogRef = this.dialog.open(AddShiftComponent, {
      enterAnimationDuration: "300ms",
      exitAnimationDuration: "300ms",
      width: '55%',
      height: '98%',
      maxWidth: '90vw',
      autoFocus: false,
      data: newData,
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
      this.list()
    });
  }
}
